var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"active":_vm.active},on:{"close":_vm.handleCloseModal}},[(_vm.actionType == 'createModal')?_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n    Create New Project\n  ")]):_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Update Project")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d3dd56c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/pages/admin/components/modals/projectModal.vue
// module id = 292
// module chunks = 0